"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TaskDragDropContext = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createForOfIteratorHelper"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));
var _react = _interopRequireWildcard(require("react"));
require("./TaskDragDrop.css");
var _Droppable = _interopRequireDefault(require("./Droppable"));
var _Draggable = _interopRequireDefault(require("./Draggable"));
var _ModalFeedback = _interopRequireDefault(require("../ModalFeedback/ModalFeedback"));
var _CompletedContext = require("../CompletedContext");
var _AlertFeedback = _interopRequireDefault(require("../AlertFeedback/AlertFeedback"));
var _DesignComponents = require("../DesignComponents/DesignComponents");
var _ShrinkToFit = _interopRequireDefault(require("../ShrinkToFit/ShrinkToFit"));
var DEBUG = false;
function shuffle(a) {
  for (var i = a.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var _ref = [a[j], a[i]];
    a[i] = _ref[0];
    a[j] = _ref[1];
  }
  return a;
}
var TaskDragDropContext = exports.TaskDragDropContext = /*#__PURE__*/_react.default.createContext({
  mouseX: 0,
  mouseY: 0,
  mouseDown: 0,
  minX: 0,
  maxX: 0,
  minY: 0,
  maxY: 0
});
var TaskDragDrop = exports.default = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TaskDragDrop, _Component);
  var _super = (0, _createSuper2.default)(TaskDragDrop);
  function TaskDragDrop(props) {
    var _this;
    (0, _classCallCheck2.default)(this, TaskDragDrop);
    _this = _super.call(this, props);
    _this.state = props.state || {};
    if (!_this.state.initialized) {
      _this.state.initialized = true;
      // Initial state is set here, since the constructor can be called more than once.
      _this.state.completed = false;
      _this.state.feedback = undefined;
      _this.state.correct = false;
      _this.state.hotspotChildren = props.hotspots.map(function () {
        return [];
      });
      _this.state.hotspotChildren[props.hotspots.length] = props.choices.map(function (v, k) {
        v.index = k;
        return v;
      });
      _this.state.mouseX = 0;
      _this.state.mouseY = 0;
      _this.state.minX = 0;
      _this.state.maxX = 0;
      _this.state.minY = 0;
      _this.state.maxY = 0;
      _this.state.hovered = -1;
      _this.state.dropdownReset = undefined;
      _this.state.workingChoices = _this.props.choices.map(function (choice, index) {
        return {
          content: choice.content,
          sourceArray: undefined,
          index: index
        };
      });
      if (props.sort) {
        _this.state.hotspotChildren[props.hotspots.length].sort(function (a, b) {
          return (0, _DesignComponents.toText)(a.content) > (0, _DesignComponents.toText)(b.content) ? 1 : -1;
        });
      } else if (props.randomize) {
        shuffle(_this.state.hotspotChildren[props.hotspots.length]);
      }
    }
    _this.generateDraggables = _this.generateDraggables.bind((0, _assertThisInitialized2.default)(_this));
    _this.updateBounds = _this.updateBounds.bind((0, _assertThisInitialized2.default)(_this));
    _this.canDrop = _this.canDrop.bind((0, _assertThisInitialized2.default)(_this));
    _this.updateHotspotsAfterDrop = _this.updateHotspotsAfterDrop.bind((0, _assertThisInitialized2.default)(_this));
    _this.ref = /*#__PURE__*/_react.default.createRef();
    _this.hotspotMap = {};
    return _this;
  }
  (0, _createClass2.default)(TaskDragDrop, [{
    key: "isTask",
    value: function isTask() {
      return true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops, prevstate, snapshot) {
      if (this.state.hotspotChildren !== prevstate.hotspotChildren) {
        var completed = true;
        for (var i = 0; i < this.state.hotspotChildren.length - 1; i++) {
          if (this.state.hotspotChildren[i].length === 0) {
            completed = false;
          }
        }
        if (this.props.submit) {
          this.setState({
            canSubmit: completed
          });
        } else {
          this.setState({
            completed: completed,
            feedback: completed ? this.props.feedbackCorrect : this.state.feedback
          });
        }
      }
      if (prevstate.completed !== this.state.completed || prevstate.taskId !== this.state.taskId) {
        // Make sure our parent knows about the completion
        this.context.onCompleted(this.state.completed, this.state.taskId);
      }
      if (this.props.hotspots.length !== prevprops.hotspots.length) {
        var temp = this.props.hotspots.map(function () {
          return [];
        });
        temp[this.props.hotspots.length] = this.props.choices.map(function (v, k) {
          v.index = k;
          return v;
        });
        temp[this.props.hotspots.length].sort(function (a, b) {
          return (0, _DesignComponents.toText)(a.content) > (0, _DesignComponents.toText)(b.content) ? 1 : -1;
        });
        this.setState({
          hotspotChildren: temp
        });
      }
      for (var _i = 0, _Object$keys = Object.keys(this.state); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        // Keep our stored state synchronized
        if (this.state[key] !== this.props.state[key]) {
          this.props.state[key] = this.state[key];
        }
      }
      if (this.state.dropdownReset !== undefined) {
        this.setState({
          dropdownReset: undefined
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      // Notify the parent of our completion status
      this.context.registerTask(function (id) {
        _this2.setState({
          taskId: id
        });
      });
      this.context.onCompleted(this.state.completed, this.state.taskId);
      window.addEventListener("resize", this.updateBounds);
      this.updateBounds();
      window.setTimeout(function () {
        _this2.updateBounds();
        window.setTimeout(function () {
          _this2.updateBounds();
        }, 0);
      }, 0);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.updateBounds);
    }
  }, {
    key: "updateBounds",
    value: function updateBounds() {
      if (!this.ref.current) return;
      var rect = this.ref.current.getBoundingClientRect();
      if (this.state.minX !== rect.left || this.state.maxX !== rect.right || this.state.minY !== rect.top || this.state.maxY !== rect.bottom) {
        this.setState({
          minX: rect.left,
          maxX: rect.right,
          minY: rect.top,
          maxY: rect.bottom
        });
      }
    }
  }, {
    key: "generateDraggables",
    value: function generateDraggables(children, droppableId, hidden) {
      var _this3 = this;
      var childrenarray = [];
      if (children === undefined) return [];
      this.hotspotMap[droppableId] = [];
      children.forEach(function (v, k) {
        if (!v) return;
        _this3.hotspotMap[droppableId][k] = droppableId + ";" + k + ";" + v.index;
        children[k].sourceArray = _this3.hotspotMap[droppableId][k];
        _this3.state.workingChoices.forEach(function (item, i) {
          if (v.content === item.content) {
            _this3.state.workingChoices[i] = v;
            _this3.state.workingChoices[i].sourceArray = droppableId + ";" + k + ";" + v.index;
            _this3.state.workingChoices[i].choiceIndex = i;
          }
        });
        DEBUG && console.log("TaskDragDrop generateDraggables assigning id", k, _this3.hotspotMap[droppableId], _this3.hotspotMap[droppableId][k]);
        childrenarray.push( /*#__PURE__*/_react.default.createElement(_Draggable.default, {
          id: _this3.hotspotMap[droppableId][k],
          labelWidth: _this3.props.labelWidth,
          labelHeight: _this3.props.labelHeight,
          labelColor: _this3.props.labelColor,
          ariaHidden: hidden,
          key: k,
          dragging: _this3.state.dragging === v.index,
          onDragStart: function onDragStart() {
            _this3.setState({
              dragging: v.index
            });
          },
          onDragEnd: function onDragEnd() {
            _this3.setState({
              dragging: undefined
            });
          }
        }, v.content));
      });
      return childrenarray;
    }
  }, {
    key: "canDrop",
    value: function canDrop(source, destination, choice) {
      DEBUG && console.log("TaskDragDrop canDrop", source, destination, choice);
      if (this.state.completed || this.state.hotspotChildren[destination].length && !this.props.submit) {
        DEBUG && console.log("TaskDragDrop canDrop 1", this.state.hotspotChildren[destination], !this.props.submit);
        return false;
      }
      if (destination === this.props.hotspots.length) {
        DEBUG && console.log("TaskDragDrop canDrop 2", this.props.hotspots.length);
        this.setState({
          feedback: undefined
        });
      } else if (!this.props.submit) {
        var correct = this.props.hotspots[destination].correct.includes(choice);
        DEBUG && console.log("TaskDragDrop canDrop 3", correct);
        this.setState({
          correct: correct,
          feedback: this.props.feedback ? this.props.feedback[destination][choice] : correct ? undefined : this.props.feedbackIncorrect,
          showModal: !correct ? true : null
        });
        return correct;
      }
      DEBUG && console.log("TaskDragDrop canDrop 4");
      return true;
    }
  }, {
    key: "updateHotspotsAfterDrop",
    value: function updateHotspotsAfterDrop(ids, accessibleLocation) {
      // let ids = this.state.dragElement.id.split(";")
      var source = Number(ids[0]); // The source array
      var destination = this.state.hovered === -1 ? accessibleLocation : this.state.hovered; // The destination array
      var child = Number(ids[1]); // The index in the source array the child came from
      var choice = Number(ids[2]); // The index in props.choices the child came from
      var childrenAtDestination = this.state.hotspotChildren.slice()[destination];
      DEBUG && console.log("TaskDragDrop updateHotspotsAfterDrop", ids, accessibleLocation, source, destination, child, choice);
      if (source !== destination) {
        DEBUG && console.log("TaskDragDrop updateHotspotsAfterDrop source !== destination");
        if (this.canDrop(source, destination, choice)) {
          var _this$props$hotspots$, _this$props$hotspots$2, _this$ref$current;
          DEBUG && console.log("TaskDragDrop updateHotspotsAfterDrop doing");
          var hotspotChildren = this.state.hotspotChildren.slice();
          var indexToReplace = -1;
          DEBUG && console.log(childrenAtDestination.length, "compared to ", (_this$props$hotspots$ = this.props.hotspots[destination]) === null || _this$props$hotspots$ === void 0 ? void 0 : _this$props$hotspots$.correct.length);
          if (childrenAtDestination.length >= ((_this$props$hotspots$2 = this.props.hotspots[destination]) === null || _this$props$hotspots$2 === void 0 ? void 0 : _this$props$hotspots$2.correct.length)) {
            // if the hotspot is full
            for (var i = 0; i < childrenAtDestination.length; i++) {
              var droppableInPlace = document.getElementById(childrenAtDestination[i].sourceArray).getBoundingClientRect();
              if (
              // is overlapping another droppable
              droppableInPlace.left <= this.state.mouseX &&
              // Left
              droppableInPlace.right >= this.state.mouseX &&
              // Right
              droppableInPlace.top + window.scrollY <= this.state.mouseY &&
              // Top
              droppableInPlace.bottom + window.scrollY >= this.state.mouseY) {
                indexToReplace = i;
                var displaced = hotspotChildren[destination].splice(i, 1);
                hotspotChildren[source].push(displaced[0]);
              }
            }
            if (indexToReplace === -1)
              // did not hover another droppable
              return;
          } else {
            indexToReplace = hotspotChildren[destination].length;
          }
          var removed = hotspotChildren[source].splice(child, 1);
          DEBUG && console.log("TaskDragDrop updateHotspotsAfterDrop displacing");
          hotspotChildren[destination].splice(indexToReplace, 0, removed[0]);
          DEBUG && console.log("TaskDragDrop updateHotspotsAfterDrop hotspotChildren", hotspotChildren);
          this.setState({
            hotspotChildren: hotspotChildren
          });
          (_this$ref$current = this.ref.current) === null || _this$ref$current === void 0 ? void 0 : _this$ref$current.focus();
        }
      }
    }
  }, {
    key: "renderWordBank",
    value: function renderWordBank(props) {
      var _this4 = this;
      var onlyDropdown = this.props.onlyDropdown;
      var children = this.generateDraggables(this.state.hotspotChildren[this.props.hotspots.length], this.props.hotspots.length, true);
      return /*#__PURE__*/_react.default.createElement(_Droppable.default, {
        onlyDropdown: onlyDropdown,
        choices: this.state.workingChoices,
        className: "wordbank" + (onlyDropdown ? " d-none" : ""),
        style: {
          width: this.props.wordBankLabelWidth ? this.props.wordBankLabelWidth : "auto",
          height: this.props.wordBankLabelHeight ? this.props.wordBankLabelHeight : "auto"
        },
        dragElement: this.state.dragElement,
        hovered: this.state.hovered === this.props.hotspots.length,
        completed: this.state.completed,
        onHover: function onHover() {
          _this4.setState({
            hovered: _this4.props.hotspots.length
          });
        },
        onEndHover: function onEndHover() {
          _this4.setState({
            hovered: _this4.state.hovered === _this4.props.hotspots.length ? -1 : _this4.state.hovered
          });
        }
      }, children);
    }
  }, {
    key: "renderFigure",
    value: function renderFigure() {
      var _this5 = this;
      var Stuff = function Stuff() {
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _this5.props.picture ? /*#__PURE__*/_react.default.createElement("img", {
          src: _this5.props.picture,
          alt: _this5.props.pictureAlt,
          style: {
            width: _this5.props.pictureWidth || "100%"
          }
        }) : _this5.props.children, _this5.props.picture && /*#__PURE__*/_react.default.createElement(TaskDragDrop.Hotspots, {
          parent: _this5
        }));
      };
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "figure figure-outer"
      }, this.props.responsive ? /*#__PURE__*/_react.default.createElement(_ShrinkToFit.default, {
        disableClipping: true,
        innerClass: "figure figure-inner",
        textAdjust: this.props.textAdjust
      }, Stuff()) : Stuff());
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;
      this.props.choices.forEach(function (c, i) {
        if (!c.accessibleLabel) {
          throw new Error("TaskDragDrop: choice " + i + " was missing an accessible label.");
        }
      });
      var onlyDropdown = this.props.onlyDropdown;
      return /*#__PURE__*/_react.default.createElement("div", {
        ref: this.ref,
        tabIndex: "-1",
        className: "task task-drag-drop" + (this.props.responsive ? " responsive" : "") + (this.props.vertical ? " vertical" : ""),
        onMouseMove: onlyDropdown ? undefined : function (e) {
          var x = e.nativeEvent.pageX;
          var y = e.nativeEvent.pageY;
          _this6.setState({
            mouseX: x,
            mouseY: y
          });
          _this6.updateBounds();
        },
        onMouseLeave: onlyDropdown ? undefined : function (e) {
          _this6.setState({
            mouseDown: false,
            dragElement: undefined,
            hovered: -1,
            dragging: undefined
          });
        },
        onMouseDown: onlyDropdown ? undefined : function (e) {
          var node = e.target;
          DEBUG && console.log("TaskDragDrop onMouseDown", node, node.id);
          while (node && !(node.id && node.id.includes(";"))) {
            node = node.parentNode;
          }
          DEBUG && console.log("TaskDragDrop onMouseDown 2", node, node.id);
          if (node && node.id && node.id.includes(";")) DEBUG && console.log("TaskDragDrop onMouseDown dragging", node);
          _this6.setState({
            mouseDown: true,
            dragElement: node
          });
        },
        onMouseUp: onlyDropdown ? undefined : function () {
          DEBUG && console.log("TaskDragDrop onMouseUp", _this6.state.mouseDown, _this6.state.dragElement, _this6.state.hovered);
          if (_this6.state.mouseDown && _this6.state.dragElement && _this6.state.hovered !== -1) {
            _this6.updateHotspotsAfterDrop(_this6.state.dragElement.id.split(";"));
          }
          _this6.setState({
            mouseDown: false,
            dragElement: undefined,
            hovered: -1,
            dragging: undefined
          });
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "content"
      }, /*#__PURE__*/_react.default.createElement(TaskDragDropContext.Provider, {
        value: {
          mouseX: this.state.mouseX,
          mouseY: this.state.mouseY,
          mouseDown: this.state.mouseDown,
          minX: this.state.minX,
          maxX: this.state.maxX,
          minY: this.state.minY,
          maxY: this.state.maxY,
          parent: this,
          onlyDropdown: onlyDropdown
        }
      }, this.props.vertical ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.renderWordBank(), this.renderFigure()) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.renderFigure(), this.renderWordBank()))), this.props.submit && !this.state.completed && /*#__PURE__*/_react.default.createElement(_DesignComponents.Button, {
        className: "bdg-submit-button",
        type: "submit",
        disabled: !this.state.canSubmit,
        onClick: function onClick() {
          var incorrectCount = _this6.state.hotspotChildren[_this6.state.hotspotChildren.length - 1].length;
          var completed = incorrectCount === 0;
          for (var i = 0; i < _this6.state.hotspotChildren.length - 1; i++) {
            if (_this6.state.hotspotChildren[i].length === 0) {
              incorrectCount = incorrectCount + 1;
              completed = false;
            } else {
              var _iterator = (0, _createForOfIteratorHelper2.default)(_this6.state.hotspotChildren[i]),
                _step;
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var child = _step.value;
                  var choice = child.choiceIndex;
                  console.log("CHILD", child, _this6.state.hotspotChildren[i]);
                  var c = _this6.props.hotspots[i].correct.includes(choice);
                  if (!c) {
                    incorrectCount = incorrectCount + 1;
                    completed = false;
                    var hotspotChildren = _this6.props.hotspots.map(function () {
                      return [];
                    });
                    hotspotChildren[_this6.props.hotspots.length] = _this6.props.choices.map(function (v, k) {
                      v.index = k;
                      return v;
                    });
                    console.log("i", i, "choice", choice, "feedback", _this6.props.feedback);
                    _this6.setState({
                      correct: false,
                      feedback: _this6.props.feedback ? _this6.props.feedback[i][choice] || _this6.props.feedbackIncorrect : _this6.props.feedbackIncorrect,
                      showModal: true,
                      hotspotChildren: hotspotChildren
                    });
                  }
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            }
          }
          console.log("NUM WRONG", incorrectCount, _this6.state.hotspotChildren.length);
          if (incorrectCount > 0) {
            _this6.setState({
              feedback: _this6.props.feedbackIncorrect,
              correct: false,
              showModal: true
            });
          }
          if (completed) {
            _this6.setState({
              completed: true,
              correct: true,
              feedback: _this6.props.feedbackCorrect
            });
          }
        }
      }, "Submit"), this.state.feedback && this.state.correct && /*#__PURE__*/_react.default.createElement(_AlertFeedback.default, {
        feedback: this.state.feedback
      }), /*#__PURE__*/_react.default.createElement(_ModalFeedback.default, {
        show: this.state.showModal && !this.state.completed && !onlyDropdown,
        onHide: function onHide() {
          _this6.setState({
            showModal: false,
            dropdownReset: ""
          });
        }
      }, this.state.feedback));
    }
  }], [{
    key: "Hotspots",
    value: function Hotspots(props) {
      return /*#__PURE__*/_react.default.createElement(TaskDragDropContext.Consumer, null, function (value) {
        var parent = props.parent || value.parent;
        var parentProps = parent.props;
        var parentState = parent.state;
        return parentProps.hotspots.map(function (v, k) {
          if (props.index !== undefined && k !== props.index) return undefined;
          if (parentProps.hotspots[k].hotspotLabel === undefined && parentProps.hotspots[k].labelId === undefined) {
            throw new Error("TaskDragDrop.Hotspots: Hotspot " + k + " needs prop 'hotspotLabel' or 'labelId");
          }
          return parentState.hotspotChildren[parentProps.hotspots.length] && /*#__PURE__*/_react.default.createElement(_Droppable.default, {
            onlyDropdown: value.onlyDropdown,
            key: k,
            dropdownReset: parentState.dropdownReset,
            active: parentState.dragging !== undefined,
            submit: parentProps.submit,
            hotspotLabel: parentProps.hotspots[k].hotspotLabel,
            labelId: parentProps.hotspots[k].labelId,
            dropdownPlacement: parentProps.dropdownPlacement,
            className: "hotspot" + (parentState.hotspotChildren[k].length && !parentProps.submit ? " disabled" : ""),
            updateHotspotsAfterDrop: parent.updateHotspotsAfterDrop,
            accessibleLocation: k,
            choices: parentState.workingChoices,
            unplacedChoices: parentProps.submit ? undefined : parentState.hotspotChildren[parentProps.hotspots.length].map(function (obj) {
              return obj ? obj.choiceIndex : undefined;
            }),
            style: (0, _objectSpread2.default)({
              position: "absolute"
            }, v.style),
            hotspot: v,
            dragElement: parentState.dragElement,
            hovered: parentState.hovered === k,
            placeholder: parentProps.placeholder,
            onHover: function onHover() {
              parent.setState({
                hovered: k
              });
            },
            onEndHover: function onEndHover() {
              parent.setState({
                hovered: parentState.hovered === k ? -1 : parentState.hovered
              });
            }
          }, parent.generateDraggables(parentState.hotspotChildren[k], k));
        });
      });
    }
  }]);
  return TaskDragDrop;
}(_react.Component);
TaskDragDrop.contextType = _CompletedContext.CompletedContext;